import dayjs from "dayjs";

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

/**
 * Converte valor do DatePicker / Date / string em YYYY-MM-DD (calendário local).
 * Retorna "" se vazio ou inválido.
 */
export function formatarDataIsoLocal(value) {
  if (value === null || value === undefined || value === "") {
    return "";
  }
  if (typeof value === "string" && ISO_DATE.test(value.trim())) {
    return value.trim();
  }
  const d = dayjs(value);
  if (!d.isValid()) {
    return "";
  }
  return d.format("YYYY-MM-DD");
}

/**
 * Exibe data da API (ISO com T ou YYYY-MM-DD) como DD/MM/YYYY sem deslocar fuso.
 */
export function formatarDataExibicaoBr(value) {
  if (value === null || value === undefined || value === "") {
    return "";
  }
  const s = String(value);
  const isoDay = s.includes("T") ? s.split("T")[0] : s.slice(0, 10);
  if (ISO_DATE.test(isoDay)) {
    const [y, m, d] = isoDay.split("-");
    return `${d}/${m}/${y}`;
  }
  const parsed = dayjs(value);
  if (!parsed.isValid()) {
    return "";
  }
  return parsed.format("DD/MM/YYYY");
}

/**
 * true se início e fim forem válidos e início > fim.
 */
export function intervaloDatasInvalido(dtInicio, dtFim) {
  const ini = formatarDataIsoLocal(dtInicio);
  const fim = formatarDataIsoLocal(dtFim);
  if (!ini || !fim) {
    return false;
  }
  return ini > fim;
}
